import StudentPanelsConfig from '../../student-container/student-panels.config';

const AttendancePanelConfig = {
  title: StudentPanelsConfig.ATTENDANCE.human,
  paths: [
    'isHs',
    'att.currSy.daysAbs',
    'att.currSy.daysLate',
    'att.currSy.abs',
    'att.currSy.late',
    'att.currTerm.daysAbs',
    'att.currTerm.daysLate',
    'att.currTerm.abs',
    'att.currTerm.late',
    'att.last5.daysAbs',
    'att.last5.daysLate',
    'att.last5.abs',
    'att.last5.late',
    'att.last20.daysAbs',
    'att.last20.daysLate',
    'att.last20.abs',
    'att.last20.late',
    'att.absStreak',
    'att.lateStreak',
    'schoolDetails.termStructure',
  ],
};

export default AttendancePanelConfig;
